import {getProductDataImageUrl, getProductDataUrl} from './data_utils';
import {newProductCard} from 'utils/constants/signalmanConstants';

export function getCategoryName(hit, index) {
  return hit.breadcrumbs?.[index]?.name?.toLowerCase()?.replace(/\s/g, '_');
}

export function fireEcommerceEvent(
  ecommerceEventPayload,
  eventName,
  eventAttributes = {}
) {
  window.dataLayer.push({
    ecommerce: null
  });
  window.dataLayer.push({
    ecommerce: ecommerceEventPayload,
    event: eventName,
    ...eventAttributes
  });
}

export function getProductLink(hit) {
  if (hit.target_url) {
    return hit.target_url;
  }
  return hit.breadcrumbs && hit.breadcrumbs[hit.breadcrumbs.length - 1]?.path;
}

export function getProductImpressionsEventPayload(
  hit,
  index,
  additionalData = {}
) {
  return {
    brand: hit.manufacturer,
    category: hit?.breadcrumbs
      ?.map((cat) => cat.name)
      .splice(0, (hit?.breadcrumbs?.length ?? 0) - 1),
    id: hit.product_id,
    image: getProductDataImageUrl(hit.product_id),
    name: hit.name,
    position: index + 1,
    url: getProductDataUrl(getProductLink(hit)),
    ...additionalData
  };
}

export function fireCardImpressionEvent(cardImpressionsPayload) {
  window.dataLayer.push({
    [`ci.catalog.listingsImpression`]: cardImpressionsPayload,
    event: `ci.catalog.listingImpression`
  });
}

export function fireListingsImpressionsEvents(
  hits,
  isCustomPage,
  isSearchResults
) {
  hits.forEach((hit, index) => {
    const cardImpressionsPayload = getProductImpressionsEventPayload(
      hit,
      index,
      {
        listing: getListingImpressionsName({
          isCustomPage,
          isSearchResults
        })
      }
    );
    fireCardImpressionEvent(cardImpressionsPayload);
  });
}

export function getItemEcomerceData(hit, index, additionalData = {}) {
  return {
    index,
    item_brand: hit.manufacturer,
    item_category: getCategoryName(hit, 0),
    item_category2: getCategoryName(hit, 1),
    item_category3: getCategoryName(hit, 2),
    item_id: Number(hit.product_id),
    item_name: hit.name,
    ...additionalData
  };
}

export function getEcommerceEventPayload(
  items,
  categoryId,
  categoryTree,
  searchTerm
) {
  return {
    ecommerce: {
      item_list_id: categoryId,
      item_list_name: categoryTree,
      items
    },
    search_term: searchTerm
  };
}

export function getListingImpressionsName({isCustom, isSearchResults}) {
  // TODO: Check if still support this as there's not class `is-Custom` in the codebase
  if (isCustom) {
    return 'Listing Custom';
  }
  if (isSearchResults) {
    return 'Search Results';
  }
  return 'Listing';
}

export function fireProductCardTestSplitEvent() {
  window.dataLayer.push({
    ab_test_group: newProductCard,
    ab_test_location: 'plp catalog',
    ab_test_name: `new product card 2025 05 05`,
    event: 'ab_test_group'
  });
}
